import React from "react";

class TollFreeBanner extends React.Component {
  render() {
    return (
      <div id="toll-free-hero" className="main-banner item-bg-one">
        <div className="d-table">
          <div className="d-table-cell">
            <div className="container">
              <div className="row">
                <div className="col-lg-12 col-md-12">
                  <div className="main-banner-text">
                    <h4>Connect With Confidence</h4>
                    <h1>
                      Toll Free <span>Services</span>
                    </h1>
                    <p>
                      Get nationwide reach, professional call handling, and
                      enterprise-grade reliability for your brand.
                    </p>
                    <a href="/#contact" className="btn btn-primary">
                      GET STARTED
                    </a>
                    <a href="/#services" className="btn btn-primary view-work">
                      View All Services
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default TollFreeBanner;
